import { NextButton } from '@/components/buttons/Buttons';
import Container, {
	Column,
	FlexWrap,
} from '@/components/container/Container';
import { BulletList } from '@/components/text/Lists';
import { TextBodyLarge, TextHeadlineMedium } from '@/components/text/Texts';
import { TRAVEL_PROGRAM } from '@/constants/programs';
import { OnBoardingStateProgramProps } from '../ChooseProgramWizard';
import { OnboardingProgramDto } from '@/types';
import { useMutation } from '@tanstack/react-query';

const SuggestedProgramContent = (props: OnBoardingStateProgramProps) => {
	const color = 'text-neutral17';
	const submitMutation = useMutation({
		mutationFn: async (data: Partial<OnboardingProgramDto>) => {
			await props.onSubmit(data);
		},
	});

	return (
		<FlexWrap gap="gap-8">
			<Container className="md:pl-[72px] md:w-[632px] lg:w-[632px] tablet:w-full tablet:pl-0">
				<Column gap="gap-4">
					<TextBodyLarge
						text={TRAVEL_PROGRAM.DESCRIPTION}
						className={color}
					/>
					<TextHeadlineMedium
						text={TRAVEL_PROGRAM.USE_THIS_PROGRAM_FOR}
						className={color}
					/>
					<BulletList
						listItems={TRAVEL_PROGRAM.PURPOSE}
						textStyle="text-body-large"
						markerSpacingLeft="pl-2"
					/>
					<NextButton
						onClick={() => submitMutation.mutate({})}
						width="w-[282px]"
						label="Start Your 30-Day Trial"
						withIcon={true}
						id="suggested-program-select-button"
						disabled={submitMutation.isPending}
					/>
				</Column>
			</Container>
			{/* <Column> */}
			<Container className="w-[264px] align-top h-[371px] tablet:hidden">
				<img
					className="rounded-t-[12px]"
					src="/images/image-placeholder.png"
					alt="decor"
					width={264}
					height={142}
				/>
				<Container className="h-[72px] flex align-middle bg-surface rounded-b-[12px]">
					<div className="m-auto h-[40px]" aria-hidden="true" />
				</Container>
			</Container>
			{/* </Column> */}
		</FlexWrap>
	);
};

export default SuggestedProgramContent;
